import commonMutations from '@/store/data/common/mutations'
import Vue from 'vue'
import { keyBy, map } from 'lodash'

const mutations = {
    ...commonMutations,

    setActiveItems(state, { items }) {
        Vue.set(state, 'activeList', items)
    },

    setActiveProviders(state) {
        const _activeProvidersNames = map(state.activeList, (provider, providerName) => providerName)
        Vue.set(state, 'activeProviders', _activeProvidersNames)
    },

    setCollection(state, data) {
        Vue.set(state, 'collection', keyBy(data, 'crossId'))
    },
}

export default mutations
